var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-tab-group',{attrs:{"tabs":_vm.tabs}})
}
var staticRenderFns = []

export { render, staticRenderFns }